// storage бывает заблокирован (Firefox: cookies off / приватный режим / sandboxed iframe):
// тогда даже typeof localStorage бросает SecurityError. Поэтому try/catch.

export function getSafeLocalStorage(): Storage | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null
  } catch {
    return null
  }
}

export function getSafeSessionStorage(): Storage | null {
  try {
    return typeof sessionStorage !== 'undefined' ? sessionStorage : null
  } catch {
    return null
  }
}

// document берём через globalThis: на нативе (mobile tsconfig без dom lib) прямой глобал не типизирован.
function getDocument(): { cookie: string } | undefined {
  return (globalThis as { document?: { cookie: string } }).document
}

export function safeReadCookie(): string {
  try {
    return getDocument()?.cookie ?? ''
  } catch {
    return ''
  }
}

export function safeWriteCookie(cookie: string): void {
  try {
    const doc = getDocument()

    if (doc) {
      doc.cookie = cookie
    }
  } catch {
    // storage заблокирован, игнорируем
  }
}
